import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventNames, EVENTS } from '@app/constants/events.constants';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { DocumentService, UserService } from '@app/shared/services';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { CreateNoteComponent } from '../dialog/create-note.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'notes-list-component',
  templateUrl: './notes-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotesListComponent implements OnInit, OnDestroy {
  @Input() selectedSecurity_key = null;
  @Input() note;
  @Input() securityStateObject;
  @Input() isIpadOrTabletScreenWidth;
  @Input() inlineComponent = false;
  @Input() fId;
  @Input() actionDisabled = false;
  @Input() isEditable: boolean = false;
  @Output() getNote: EventEmitter<any> = new EventEmitter();
  @Output() createNote: EventEmitter<any> = new EventEmitter();
  @Output() removeNote: EventEmitter<any> = new EventEmitter();

  noteTitle = '';
  moment = moment;
  noteContent = '';
  isHovering = false;
  subscription = new Subscription();

  constructor(private dialog: MatDialog, private _userService: UserService, private documentService: DocumentService) {}

  ngOnInit(): void {
    let parsedNoteObject = JSON.parse(this.note.vault_user_form_note_note);
    if (this.note.vault_user_form_note_updated_at)
      this.note.vault_user_form_note_updated_at = moment(this.note.vault_user_form_note_updated_at).format('MMM DD, YYYY');
    this.noteTitle = parsedNoteObject.title;
    this.noteContent = parsedNoteObject.noteContent;
  }

  editNote() {
    const dialogRef = this.dialog.open(CreateNoteComponent, {
      panelClass: 'full-window-dialog-3',
      autoFocus: false,
      data: {
        ...this.note,
        isEditing: true,
        selectedSecurity_key: this.selectedSecurity_key,
        securityStateObject: this.securityStateObject,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation.isSuccess) {
          const eventSource = this.inlineComponent ? 'setup' : 'view';
          this.trackEventsInMixPanel([{ eventName: EVENTS[`template_${eventSource}_edit_note`] }]);
          this.getNoteAFterEdit();
        }
      })
    );
  }

  deleteNote() {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Note?',
        materialIcon: 'delete',
        text: `This note will be deleted forever.`,
        proceedTitle: 'Delete',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.documentService
              .deleteNote({ userId: this.note.vault_user_form_note_created_by, noteId: this.note.vault_user_form_note_id })
              .subscribe(() => {
                const eventSource = this.inlineComponent ? 'setup' : 'view';
                this.trackEventsInMixPanel([{ eventName: EVENTS[`template_${eventSource}_delete_note`] }]);
                this.getNoteAFterEdit();
              })
          );
        }
      })
    );
  }

  trackEventsInMixPanel(events: { eventName: EventNames; data?: any }[]) {
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }

  getNoteAFterEdit() {
    this.getNote.emit('edited');
  }

  removeNoteSuggestion(title, content) {
    this.removeNote.emit({ title: title, content: content });
  }

  openCreateNoteModal(title, content) {
    this.createNote.emit({ title: title, content: content, is_suggestion_note: true });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this._userService.cleanupWorker();
  }
}
